import Button from "~/components/buttons/Button/Button";
import Hint from "~/components/Hint";
import SidebarContent from "~/components/Sidebar/components/SidebarContent";
import SidebarFooter from "~/components/Sidebar/components/SidebarFooter";
import SidebarHeader from "~/components/Sidebar/components/SidebarHeader";

type Props = {
	onClose: () => void;
};

const InvoiceIsNotDeletableSidebarContent = ({
	onClose,
}: Props) => {
	return (
		<div className="auto-grid-sidebar">
			<SidebarHeader>Rechnung löschen</SidebarHeader>
			<SidebarContent>
				<Hint theme="warning"
					  title="Rechnung kann nicht gelöscht werden">
					Die Rechnung kann nicht gelöscht werden, da sie bereits bezahlt oder storniert wurde.
				</Hint>
			</SidebarContent>
			<SidebarFooter>
				<Button theme="white"
						onClick={onClose}>
					Schließen
				</Button>
			</SidebarFooter>
		</div>
	);
};

export default InvoiceIsNotDeletableSidebarContent;
